import { Box, Divider, Grid, Stack, Typography } from '@mui/material';
import CardWrapper from '../CardWrapper';
import DetailItem from 'components/Staff/ItemDetail';
import { dateFormat, formatAmount, formatNameWithNickname } from 'utils/helpers';
import Colors from 'constants/colors';

interface TransactionData {
    name: string;
    username: string;
    transactionDateTime: string;
    type: string;
    balance: number | string;
    totalFee: number;
    transactionAmount: number;
    note: string;
    status: string;
    title: string;
    trxId: string;
}
interface CompletedTransactionDetailScreenProps {
    details?: TransactionData;
    showFeeSection?: boolean;
    backButtonNavigation?: () => void;
}
const CompletedTransactionDetailScreen = ({ details, showFeeSection, backButtonNavigation }: CompletedTransactionDetailScreenProps) => {
    const { name, username, transactionDateTime, type, balance, totalFee, note, status, title, transactionAmount, trxId } = details || {};
    return (
        <CardWrapper backButtonNavigation={backButtonNavigation}>
            <Box
                sx={{
                    paddingTop: '2rem',
                    px: '3rem',
                    height: '500px',
                }}
            >
                <Box>
                    <Typography sx={{ fontSize: '22px' }} variant="h1">
                        Transaction details
                    </Typography>
                    <Divider sx={{ my: 1 }} />
                </Box>
                <Stack justifyContent={'center'} alignItems={'center'} mt={5}>
                    <Stack gap={4} width={'100%'}>
                        <Grid container>
                            <Grid item xs={12} md={6}>
                                <DetailItem
                                    fontWeight={400}
                                    labelWidth={'30%'}
                                    label={title}
                                    value={formatNameWithNickname(name, username)}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <DetailItem
                                    fontWeight={400}
                                    labelWidth={'30%'}
                                    label="Date"
                                    value={dateFormat(transactionDateTime || '', 'MM/D/YYYY h:mm A')}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DetailItem fontWeight={400} labelWidth={'30%'} label="Type" value={type} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <DetailItem fontWeight={400} labelWidth={'30%'} label="Transaction Id" value={trxId} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DetailItem fontWeight={400} labelWidth={'30%'} label="Note" value={note} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <DetailItem fontWeight={400} labelWidth={'30%'} label="Status" value={status} />
                            </Grid>
                        </Grid>

                        <Stack bgcolor={Colors.tableRow}>
                            <Stack justifyContent={'center'} alignItems={'center'} width={'100%'}>
                                <DetailItem
                                    width={'40%'}
                                    fontWeight={400}
                                    labelWidth={'100%'}
                                    label="Transaction Amount"
                                    value={formatAmount(transactionAmount)}
                                />
                                {showFeeSection && (
                                    <>
                                        <DetailItem
                                            fontWeight={400}
                                            width={'40%'}
                                            labelWidth={'100%'}
                                            label="Fee"
                                            value={formatAmount(totalFee, 'dollar', 'TRANSFER')}
                                        />
                                        <DetailItem fontWeight={400} width={'40%'} labelWidth={'100%'} label="Total" value={balance} />
                                    </>
                                )}
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
            </Box>
        </CardWrapper>
    );
};
export default CompletedTransactionDetailScreen;
